<template>
  <div id="payments-config">
    <div class="payment-section">
      <Select
        class="scs-input"
        heading="Currency Code"
        :initial="businessCurrencyCode"
        :options="currencyCodes"
      />
    </div>
    <div class="payment-section">
      <Toggle
        class="scs-toggle scs-input"
        heading="Deposit / Retainer"
        option1="deposit"
        option2="retainer"
        :selected="depositTerminology"
        :formatter="titleCaps"
      /><Toggle
        class="scs-toggle scs-input"
        heading="Amount / Percentage"
        option1="amount"
        option2="percentage"
        :selected="depositType"
        :formatter="titleCaps"
      /><Input
        class="scs-input"
        :initialValue="depositAmount"
        placeholder="$ / %"
        heading="Amount"
      />
    </div>
    <div class="payment-section">
      <Toggle
        class="scs-toggle scs-input"
        heading="Final Payment Increment"
        option1="days"
        option2="weeks"
        :formatter="titleCaps"
        :selected="finalPaymentType"
      /><Input
        :heading="`# of ${
          finalPaymentIncrement ? finalPaymentIncrement : 0
        } before event`"
        class="scs-input"
        :initialValue="finalPaymentIncrement"
      />
    </div>
    <div class="payment-section">
      <Toggle
        class="scs-toggle scs-input"
        :option1="true"
        :option2="false"
        heading="Enable Credit Card"
        :selected="creditCardEnabled"
        :formatter="YesNoBoolean"
      /><Button
        :text="stripeButtonText"
        :processing="stripeButtonText ? false : true"
      />
    </div>
    <div class="payment-section">
      <Toggle
        :option1="true"
        :option2="false"
        class="scs-toggle scs-input"
        :selected="checkEnabled"
        :formatter="YesNoBoolean"
        heading="Enable Check Payments"
      /><Input
        class="scs-input"
        heading="Instructions"
        :initialValue="checkInstructions"
        placeholder="Put some instructions here for check payments"
      />
    </div>
    <div class="payment-section">
      <Toggle
        :option1="true"
        :option2="false"
        class="scs-toggle scs-input"
        :formatter="YesNoBoolean"
        :selected="customEnabled"
        heading="Enable Custom Payments"
      /><Input
        class="scs-input"
        heading="Instructions"
        :initialValue="customInstructions"
      />
    </div>
  </div>
</template>
<script>
import Select from "@/Components/Elements/Select.vue";
import Toggle from "@/Components/Elements/Binary.vue";
import Input from "@/Components/Elements/Input.vue";
import Button from "@/Components/UI/Button.vue";
export default {
  data() {
    return {
      currencyCodes: [
        "USD",
        "EUR",
        "JPY",
        "GBP",
        "AUD",
        "CAD",
        "CHF",
        "CNY",
        "HKD",
        "NZD",
        "SEK",
        "AED",
        "AFN",
        "ALL",
        "AMD",
        "ANG",
        "AOA",
        "ARS",
        "AWG",
        "AZN",
        "BAM",
        "BBD",
        "BDT",
        "BGN",
        "BHD",
        "BIF",
        "BMD",
        "BND",
        "BOB",
        "BOV",
        "BRL",
        "BSD",
        "BTN",
        "BWP",
        "BYN",
        "BZD",
        "CDF",
        "CHE",
        "CHW",
        "CLF",
        "CLP",
        "COP",
        "COU",
        "CRC",
        "CUC",
        "CUP",
        "CVE",
        "CZK",
        "DJF",
        "DKK",
        "DOP",
        "DZD",
        "EGP",
        "ERN",
        "ETB",
        "FJD",
        "FKP",
        "GEL",
        "GHS",
        "GIP",
        "GMD",
        "GNF",
        "GTQ",
        "GYD",
        "HNL",
        "HRK",
        "HTG",
        "HUF",
        "IDR",
        "ILS",
        "INR",
        "IQD",
        "IRR",
        "ISK",
        "JMD",
        "JOD",
        "KES",
        "KGS",
        "KHR",
        "KMF",
        "KPW",
        "KRW",
        "KWD",
        "KYD",
        "KZT",
        "LAK",
        "LBP",
        "LKR",
        "LRD",
        "LSL",
        "LYD",
        "MAD",
        "MDL",
        "MGA",
        "MKD",
        "MMK",
        "MNT",
        "MOP",
        "MRU",
        "MUR",
        "MVR",
        "MWK",
        "MXN",
        "MXV",
        "MYR",
        "MZN",
        "NAD",
        "NGN",
        "NIO",
        "NOK",
        "NPR",
        "OMR",
        "PAB",
        "PEN",
        "PGK",
        "PHP",
        "PKR",
        "PLN",
        "PYG",
        "QAR",
        "RON",
        "RSD",
        "RUB",
        "RWF",
        "SAR",
        "SBD",
        "SCR",
        "SDG",
        "SGD",
        "SHP",
        "SLL",
        "SOS",
        "SRD",
        "SSP",
        "STN",
        "SVC",
        "SYP",
        "SZL",
        "THB",
        "TJS",
        "TMT",
        "TND",
        "TOP",
        "TRY",
        "TTD",
        "TWD",
        "TZS",
        "UAH",
        "UGX",
        "USN",
        "UYI",
        "UYU",
        "UYW",
        "UZS",
        "VED",
        "VES",
        "VND",
        "VUV",
        "WST",
        "XAF",
        "XAG",
        "XAU",
        "XBA",
        "XBB",
        "XBC",
        "XBD",
        "XCD",
        "XDR",
        "XOF",
        "XPD",
        "XPF",
        "XPT",
        "XSU",
        "XTS",
        "XUA",
        "XXX",
        "YER",
        "ZAR",
        "ZMW",
        "ZWL",
      ],
      depositTerminologies: ["deposit", "retainer"],
      depositTypes: ["percent", "dollar"],
      paymentIncrementTypes: ["days", "weeks", "months"],
      timer: undefined,
      stripeButtonText: undefined,
    };
  },
  computed: {
    paymentSettings() {
      return this.$store.getters.paymentSettings;
    },
    stripeHealthy() {
      if (!this.$store.getters.paymentSettings.creditCard.Stripe.id) {
        return undefined;
      } else {
        return this.checkStripeAccountStatus();
      }
    },
    businessCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
    depositAmount() {
      return this.$store.getters.depositAmount;
    },
    depositTerminology() {
      return this.$store.getters.depositTerminology;
    },

    depositType() {
      return this.$store.getters.depositType;
    },

    finalPaymentIncrement() {
      return this.$store.getters.finalPaymentIncrement;
    },

    finalPaymentType() {
      return this.$store.getters.finalPaymentType;
    },

    creditCardEnabled() {
      return this.$store.getters.creditCardEnabled;
    },

    checkEnabled() {
      if (this.paymentSettings.check.enabled) {
        return this.paymentSettings.check.enabled;
      } else {
        return false;
      }
    },

    checkInstructions() {
      return this.$store.getters.checkInstructions;
    },
    customName() {
      return this.$store.getters.customPaymentName;
    },
    customInstructions() {
      return this.$store.getters.customPaymentInstructions;
    },
    customEnabled() {
      return this.$store.getters.customPaymentEnabled;
    },
  },
  methods: {
    titleCaps(str) {
      return str[0].toUpperCase() + str.substring(1);
    },
    YesNoBoolean(bool) {
      return bool === true ? "Yes" : "No";
    },
    async stripeHealth() {
      if (this.paymentSettings.creditCard.Stripe.id) {
        await this.$store.dispatch("stripeCheckAccount").then((res) => {
          if (res.charges_enabled) {
            this.stripeButtonText = "Stripe: Healthy";
          } else {
            this.stripeButtonText = "Stripe: Reconnect";
          }
        });
      } else {
        this.stripeButtonText = "Stripe: Connect";
      }
    },
    async autoSaveInput(value, variable) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => {
        await this.updateConfig(value, variable);
      }, 750);
    },
    async updateConfig(value, variable) {
      await this.$store.dispatch("updateConfig", {
        key: {
          userId: this.$store.state.user.userId,
          tenantId: this.$store.state.user.tenantId,
        },
        category: "payments",
        variable: variable,
        subject: value,
        api_version: this.$store.state.businessSettings.api_version,
      });
    },
  },
  created() {
    this.stripeHealth();
  },
  components: { Select, Input, Toggle, Button },
  props: [],
};
</script>
<style scoped>
@media screen {
  #payments-config {
    /* width: 100%; */
  }
  .payment-section {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    border-bottom: 1px solid var(--secondaryColor);
  }
  .scs-input {
    width: 275px;
  }

  .scs-toggle {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* justify-content: center; */
    /* align-items: center; */
  }
  @media (min-width: 800px) {
    .payment-section {
      width: 100%;
      padding: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-evenly;
      border-bottom: 1px solid var(--secondaryColor);
    }
    .scs-input {
      width: 275px;
    }

    .scs-toggle {
      display: flex;
      flex-direction: column;
      align-items: center;
      /* justify-content: center; */
      /* align-items: center; */
    }
  }
}
</style>
